// Import Assets
import PackListIllustration from '../../assets/Illustrations/Lists/PackList_Illustration.jpg';
import SumListIllustration from '../../assets/Illustrations/Lists/SumList_Illustration.jpg';

// Exports
export const packListIllustration = PackListIllustration;
export const sumListIllustration = SumListIllustration;
